import {useQuery, UseQueryResult} from '@tanstack/react-query'

import {QueryKeyName, getActionsByQuestionId} from '../../common/backend'
import {ActionItem} from '../../types'
import {usePlantUpmId} from '../usePlantUpmIdContext'

export const useQuestionActions = (questionId: string): UseQueryResult<ActionItem[]> => {
  const plantId = usePlantUpmId()

  return useQuery({
    queryKey: [QueryKeyName.GetActionItems, plantId, questionId],
    queryFn: async () => {
      return await getActionsByQuestionId({plantId, questionId})
    }
  })
}
